module.exports = __webpack_public_path__ + "img/promo.43dc5c12.svg";